export default __webpack_public_path__ + "static/Fellix-Bold-2715725743a9a04876c955a9266bedcc.eot";